import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { flushSync } from "react-dom";

import Print, { type PrintHandle} from "@components/print/print";

import dayjs from "dayjs";

import { useAuthStore } from "@user/store/auth_store";

import "./print_ticket_temp.scoped.scss";

export interface PrintTicketTempData {
  printDate: string;
  createDate: string;
  pn: string;
  kwd: string;
  trNo: string;
  sn: string;
  stockQty: string;
  reqQty: string;
  uom: string;
  wo: string;
  workShop: string;
  requesterEmpNo: string;
  requesterName: string;
}

export interface PrintTicketTempHandle {
  print: (info: any, copies?: number) => Promise<void>;
}

const PrintTicketTemp = forwardRef<PrintTicketTempHandle>((_, ref) => {
  const printRef = useRef<PrintHandle>(null);
  const [dataList, setDataList] = useState<PrintTicketTempData[]>([]);   // 배열로 변경

  const userName = useAuthStore((state) => state.userName);
  const empNo = useAuthStore((state) => state.empNo);

  useImperativeHandle(ref, () => ({
    print: async (info: any, copies: number = 1) => {
      const ticketTempData: PrintTicketTempData = {
        printDate: dayjs().format("YYYY-MMM-DD, HH:mm"),
        createDate: info.createDate,
        pn: info.pn,
        kwd: info.kwd,
        trNo: info.trNo,
        sn: info.sn,
        stockQty: info.stockQty,
        reqQty: info.reqQty,
        uom: info.uom,
        wo: info.wo,
        workShop: info.workShop,
        requesterEmpNo: info.requesterEmpNo,
        requesterName: info.requesterName
      };
      // 최소 1장 보장 + 정수화
      const count = Math.max(1, Math.floor(Number(copies) || 1));
      flushSync(() => setDataList(Array.from({ length: count }, () => ticketTempData)));
      await printRef.current?.print();
      setDataList([]);
    }
  }));

  return (
    <Print ref={printRef}>
      <div className="print-ticket-list">
        {dataList.map((data, idx) => (
          <div key={idx} className="ticket-page">
            {/* 상단 */}
            <div className="ticket-top-area">
              <p>TEMPORARY ISSUE</p>
              <div>
                <p>PRINTED</p>
                <span>{ data.printDate }</span>
                <p>REQ DATE</p>
                <span>{ dayjs(data.createDate ?? "").format("YYYY-MMM-DD, HH:mm") }</span>
              </div>
            </div>
            {/* 목록 */}
            <div className="ticket-temp">
              <div>
                <div className="ticket-temp-type1">
                  <p>ISS P/N</p><span>{data.pn ?? ""}</span>
                </div>
                <div className="ticket-temp-type1">
                  <p>DESC</p><span>{data.kwd ?? ""}</span>
                </div>
                <div className="ticket-temp-type2">
                  <p>TRACE NO</p><span>{data.trNo ?? ""}</span>
                  <p>S/N</p><span>{data.sn ?? ""}</span>
                </div>
                <div className="ticket-temp-type2">
                  <p>ON-HAND</p><span>{data.stockQty ?? ""} {data.uom ?? ""}</span>
                  <p>TRX QTY</p><span>{data.reqQty ?? ""} {data.uom ?? ""}</span>
                </div>
              </div>
              <div>
                <div className="ticket-temp-type2">
                  <p>SOURCE</p><span>{data.wo ?? ""}</span>
                  <p>SHOP</p><span>{data.workShop ?? ""}</span>
                </div>
              </div>
            </div>
            {/* 하단 */}
            <div className="ticket-bottom-area">
              <div>
                <p>REQUESTER</p>
                <span>{data.requesterEmpNo ?? ""} {data.requesterName ?? ""}</span>
              </div>
              <div>
                <p>ISSUER</p>
                <span>{empNo} {userName}</span>
                <p>RECEIPIENT</p>
                <em></em>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Print>
  );
});

export default React.memo(PrintTicketTemp);
